<div class="vehicle-groups-result">
  <!-- Members view -->
  <ng-container *ngIf="members() as membersData; else groupsView">
    <div class="members-header" *ngIf="!resultsService.isOverlay()">
      <span class="members-title">{{ membersData.groupName }}</span>
      <span class="members-count">{{
        'VEHICLE_GROUPS_RESULT.MEMBERS_COUNT'
          | translate: { count: membersData.count, total: membersData.totalCount }
      }}</span>
    </div>

    <div class="table-wrapper" *ngIf="membersData.vehicles.length > 0">
      <app-vehicles-table
        [vehicles]="membersData.vehicles"
        [canEdit]="true"
        [deleteTooltip]="removeFromGroupTooltip"
        [onRemove]="removeMemberFromGroup"
      ></app-vehicles-table>
    </div>

    <div *ngIf="membersData.vehicles.length === 0" class="empty-state">
      {{ 'VEHICLE_GROUPS_RESULT.EMPTY_MEMBERS' | translate }}
    </div>

    <ui-selected-items-snackbar
      *ngIf="selectedPlatesCount() > 0"
      [counter]="selectedPlatesCount()"
      [selectedText]="'VEHICLES.VEHICLES_SELECTED'"
      (selectAll)="selectAllDisplayedVehicles()"
      (clearAll)="clearSelectedVehicles()"
    >
      <ui-button
        [text]="'COMMON.DELETE' | translate"
        type="secondary"
        (clickAction)="removeSelectedMembers()"
      ></ui-button>
    </ui-selected-items-snackbar>
  </ng-container>

  <!-- Groups list view -->
  <ng-template #groupsView>
    <div class="groups-header">
      <span class="groups-count" *ngIf="groups().length > 0">{{
        'VEHICLE_GROUPS_RESULT.GROUPS_COUNT' | translate: { count: groups().length }
      }}</span>
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'VEHICLE_GROUPS.CREATE' | translate"
        (click)="createGroup()"
      >
        <span class="ui-icon-plus"></span>
      </button>
      <button
        type="button"
        class="header-open-btn"
        [matTooltip]="'VEHICLE_GROUPS_RESULT.OPEN_GROUPS_TOOLTIP' | translate"
        (click)="openGroupsPage()"
      >
        <span class="ui-icon-new-tab"></span>
      </button>
    </div>

    <div class="table-wrapper" *ngIf="groups().length > 0">
      <ui-dataset-table
        [data]="groups()"
        [config]="groupsTableConfig()"
        (rowAction)="onGroupRowAction($event)"
      ></ui-dataset-table>
    </div>

    <div *ngIf="groups().length === 0" class="empty-state">
      {{ 'VEHICLE_GROUPS_RESULT.EMPTY_GROUPS' | translate }}
    </div>
  </ng-template>
</div>
